export default {
  development: 'http://localhost:3080',
  production: 'https://granollers.qmkey.com/backend',
};
